<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-height="680"
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 600 : 'auto'"
    style="z-index: 1100 !important;"
  >

    <div class="vb-dialog vb-dialog-danger">
      <v-card v-cloak >
        <v-card-title class="d-flex justify-space-between">
          {{$t('console.removeTenantConnection')}}

          <v-btn icon @click="dialog = false;">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text scrollable class="scrollable mt-4">
          <span>
            {{ $t('console.confirmRemoveTenantConnection') }}
          </span>
          <br/>
          <br/>
          <strong>{{ tenantConnection?.name }}</strong>
        </v-card-text>


        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn type="submit"
            class="bg-red-darken-3"
            elevation=0
            v-bind:loading="isSubmitted"
            v-bind:disabled="isSubmitted"
            @click="removeConnection()"
          >
            {{$t('console.removeConnection')}}
          </v-btn>
          <v-btn variant="text" @click="dialog = false">{{ $t('common.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore.js';
import { useTenantConnectionsStore } from '@/stores/TenantConnectionsStore.js';
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';
import DialogModel from '@/components/mixin/DialogModel.js';

export default {
  mixins: [DialogActionKeys, DialogModel],
  name: "DisconnectTenantDialog",
  props: {
    tenantConnection: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      isSubmitted: false,

      errorMessage: '',
      successMessage: '',
    };
  },
  watch: {
    tenantConnection: {
      handler() {
        // this.initializeData();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    resetForm() {
      this.isSubmitted = false;
      this.errorMessage = '';
      this.successMessage = '';
    },

    async removeConnection() {
      const tenantConnectionsStore = useTenantConnectionsStore();

      if (!this.rootNodeId || !this.tenantConnection) {
        return;
      }

      try {
        this.isSubmitted = true;

        await tenantConnectionsStore.removeTenantConnection(this.rootNodeId, this.tenantConnection.id)
        this.dialog = false;
        await tenantConnectionsStore.refreshHomeTenantsList(this.rootNodeId);
        await tenantConnectionsStore.refreshAwayTenantsList(this.rootNodeId);
      } catch (error) {
        console.error(error);

        let errorMessage = this.$t('console.connectionDisconnectError');
        if (error && error.response && error.response.data && error.response.data.error) {
          errorMessage = this.$replaceT(error.response.data.error.code);
        }

        this.$showMessage(errorMessage, { type: 'error' });
      } finally {
        this.isSubmitted = false;
      }
    },
  },
  computed: {
    rootNodeId: function() {
      const authStore = useAuthStore();
      return authStore.rootNodeId;
    },
  }
}
</script>
